module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADNSURBVHgBhZLNDYMwDIVjkwHYoIzQTtCyQXvkyGRUYgBGYIWOkBG485O+IKVKIU58imx/z45t6vv+ba29r+tat21rVMK6riu11gPyK+TfGL4LEVVFUYwIVhlwxPPBzAqFJl6W5QXHJyUQgFfkGeTVzk/HIFoy4RdiYNM05gdLAnhPEvgHxwQATBJ4go8Ce4IAOtMqY9u2qXmeozGWqrqKKrMFlkDXKtZYpwRIAv0fU2ukFBjrKhQg3PYA5zM1VUFgv+0yBzpzt+xn4G/7C2DGsOTWQ0XsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workOrderReview/close.png
// module id = Z7sx
// module chunks = 0